<script>
import SafehavenUnauthAppBar from '@/src/components/layout/safehaven-unauth-app-bar.vue'
import ScrollToTopButton from '@/src/components/scroll-to-top-button.vue'
export default {
  components: {
    SafehavenUnauthAppBar,
    ScrollToTopButton,
  },
}
</script>

<template>
  <div :class="$style.mainwrapp">
    <SafehavenUnauthAppBar></SafehavenUnauthAppBar>
    <v-main>
      <v-container
        :class="$style.mainContainer"
        class="fill-height background pa-0"
        fluid
      >
        <!-- main slot -->
        <slot />
        <!-- scroll to top button -->
        <ScrollToTopButton></ScrollToTopButton>
      </v-container>
    </v-main>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.mainwrapp {
  position: relative;
  overflow: hidden;
}
</style>
